import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerGoals: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { goalsRequestHandler } = await import("./mocks/goalsRequestHandler.ts");

        runtime.registerRequestHandlers([goalsRequestHandler]);
    }
};
